import Checkbox from 'components/Generic/Checkbox';
import Loader from 'components/Generic/Loader';
import { useMemo } from 'react';
import styles from '../../styles/MobileBaseFiltersDropdownOption.module.scss';

type Props = {
  filterOption: any;
  isFetching: boolean;
  isVisible: boolean;
  optionSelect: (option) => void;
};

const MobileBaseFiltersDropdownOption = ({
  filterOption,
  isFetching,
  isVisible,
  optionSelect,
}: Props) => {
  const disabled = useMemo(() => {
    return (
      ((filterOption.showAggregateCount ? !filterOption.aggregateCount : false) &&
        !filterOption.selected) ||
      isFetching
    );
  }, [filterOption, isFetching]);

  const optionClickHandler = () => {
    if (!disabled) {
      optionSelect(filterOption);
    }
  };
  return (
    <div
      role="button"
      tabIndex={!disabled && isVisible ? '0' : '-1'}
      className={`d-flex ${styles['filter-dropdown-option']} w-100 ${
        disabled ? styles.disabled : ''
      }`}
      onClick={optionClickHandler}
      onKeyDown={(e) => {
        if (e.code === 'Enter' || e.code === 'Space') {
          optionClickHandler();
        }
      }}
    >
      <Checkbox
        tabIndex="-1"
        selected={filterOption.selected}
        label={filterOption.text}
        className="pe-none"
      />
      {filterOption.showAggregateCount && (
        <div className="d-flex">
          {isFetching ? (
            <Loader loading={isFetching} />
          ) : (
            <p className="ms-auto">
              {filterOption.aggregateCount}
              <span className="sr-only">
                funds. {filterOption.selected ? 'checked' : 'not checked'}.
              </span>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default MobileBaseFiltersDropdownOption;
